import { render } from "./Statute.vue?vue&type=template&id=132e4cea&scoped=true"
import script from "./Statute.vue?vue&type=script&lang=js"
export * from "./Statute.vue?vue&type=script&lang=js"

import "./Statute.vue?vue&type=style&index=0&id=132e4cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132e4cea"]])

export default __exports__